<template>
  <div class="serial-search">
    <label class="serial-search__label">
      {{ title }}
    </label>
    <div class="serial-search__container">
      <input class="serial-search__input"
             type="text" id="search" 
             v-model="productStore.search" 
             @input="onInput"/>
      <a class="serial-search__clear-input" @click="clearInput"><span class="icon icon--cross"></span></a>
    </div>
  </div>
</template>

<script setup>
  import { useProductStore } from '../store/store';
  const productStore = useProductStore();
  
  defineProps({
    title:'',
  });

  function clearInput() {
    productStore.search = '';
  }

  const emit = defineEmits(['searchInput']);
  
</script>